/**
 * Basic EIdentifyPage
 * Redirects when using HTML5 history api to the provided url.
 */
import {
    startLoadingEIdentifyProviders,
    IEIdentifyProvider,
    getEIdentifyProviders,
    startLoadingEIdentifyRedirectUri,
    getEIdentifyRedirectUri,
    getEIDentifyLoading,
} from "../../ducks/eidentify";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect } from "react-redux";
import React from "react";
import { Redirect, RouteComponentProps } from "react-router";
import { Grid, Typography } from "material-ui";
import { SetHeader, SetShowBackNavigation } from "../../ducks/common";
import logger from "../../util/logger";
import { env } from "../../util/env";
import {
    unlockScreenOrientation,
    lockScreenOrientationToPortrait,
} from "../../util/screen";
import FullPageSpinner from "../../components/FullPageSpinner/FullPageSpinner";
import { Banks } from "./components/Banks/Banks";
import { IsCordova } from "util/platformUtils";

/**
 * Props provided by redux
 */
interface IEIdentifyPageStateProps {
    providerData: IEIdentifyProvider[] | null;
    redirectUri: string | null;
    loadingData: boolean;
}

/**
 * Props provided by route component
 */
interface IEIdentifyPageRouteProps {
    requestType?: number;
}

/**
 * Dispatch functions provided by redux
 */
interface IEIdentifyPageDispatchProps {
    SetHeaderValue: (header: string) => void;
    LoadProviderData: () => Promise<void>;
    LoadEIdentifyRedirecturi: (
        requestType: number,
        id: number
    ) => Promise<void>;
    ShowBackNavigation: () => void;
    HideBackButton: () => void;
}

interface State {
    isInAppBrowserOpen: boolean;
    redirect: boolean;
    routeParams: string;
    error: boolean;
    return: boolean;
    loading: boolean;
}
/**
 * Combined properties of the component
 */
type IEIdentifyPageProps = IEIdentifyPageStateProps &
    IEIdentifyPageDispatchProps &
    RouteComponentProps<IEIdentifyPageRouteProps>;

const styles = {};

function getUrlParameter(name: string, searchString: string) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(searchString);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
}

class EIdentifyPage extends React.Component<IEIdentifyPageProps, State> {
    constructor(props: IEIdentifyPageProps) {
        super(props);
        this.state = {
            isInAppBrowserOpen: false,
            redirect: false,
            error: false,
            return: false,
            routeParams: "",
            loading: true,
        };
    }

    componentWillMount() {
        unlockScreenOrientation();
        const requestType =
            this.props.match.params.requestType &&
            this.props.match.params.requestType !== 0
                ? this.props.match.params.requestType
                : undefined;

        const token = getUrlParameter("token", this.props.location.search);
        const to =
            (this.props.location!.state &&
                this.props.location!.state.pathname) ||
            "/";
        const from =
            (this.props.location!.state && this.props.location!.state.from) ||
            "/";

        const code = getUrlParameter("code", this.props.location.search);

        if (!code) {
            this.props
                .LoadProviderData()
                .then(() => this.setState({ loading: false }))
                .catch((err) => {
                    logger.error(err);
                    this.setState({ loading: false });
                });
        }
    }

    componentDidMount() {
        this.props.SetHeaderValue("Tunnistautuminen");
        //this.props.ShowBackNavigation();
    }

    componentWillUnmount() {
        this.props.SetHeaderValue("");
        this.props.HideBackButton();
        lockScreenOrientationToPortrait();
    }

    openInAppBrowser() {
        const target = "_blank";
        const options = "location=no,enableviewportscale=yes,zoom=no";
        const baseUrl = `${env.APP_ROOT}/eidentify`;
        this.setState({ ...this.state, isInAppBrowserOpen: true });
        try {
            if (cordova) {
                const requestType =
                    this.props.match.params.requestType ||
                    parseInt(
                        getUrlParameter("state", this.props.location.search),
                        10
                    ) ||
                    2;
                // tslint:disable-next-line:no-any
                let ref = (cordova as any).InAppBrowser.open(
                    `${baseUrl}/${requestType}`,
                    target,
                    options
                );
                // tslint:disable-next-line:no-any
                ref.addEventListener("loadstart", (event: any) => {
                    const code =
                        event &&
                        event.url &&
                        `${event.url}`.startsWith(baseUrl) &&
                        getUrlParameter("code", event.url);
                    const error =
                        event &&
                        event.url &&
                        `${event.url}`.startsWith(baseUrl) &&
                        getUrlParameter("error", event.url);
                    if (code) {
                        ref.close();
                        let query = "?" + `${event.url}`.split("?")[1];
                        this.setState({
                            ...this.state,
                            isInAppBrowserOpen: false,
                            redirect: true,
                            routeParams: query,
                        });
                    }
                    if (error) {
                        ref.close();
                        this.setState({
                            ...this.state,
                            isInAppBrowserOpen: false,
                            redirect: true,
                            error: true,
                        });
                    }
                });
                // tslint:disable-next-line:no-any
                ref.addEventListener("exit", (event: any) => {
                    if (!this.state.redirect) {
                        this.setState({
                            ...this.state,
                            isInAppBrowserOpen: false,
                            redirect: true,
                            return: true,
                        });
                    }
                });
            }
        } catch (e) {
            logger.info("No Cordova");
        }
    }

    handleClick = (id: number) => {
        const requestType =
            this.props.match.params.requestType ||
            parseInt(
                getUrlParameter("state", this.props.location.search),
                10
            ) ||
            2;
        this.props.LoadEIdentifyRedirecturi(requestType, id).then(() => {
            if (this.props.redirectUri != null) {
                window.location.assign(this.props.redirectUri);
            } else {
                this.setState({ error: true });
            }
        });
    };

    public render() {
        const code = getUrlParameter("code", this.props.location.search);
        const isWithdrawIdentify = this.props.history.location.pathname.includes(
            "eidentify/5"
        );

        if (code && !IsCordova) {
            return (
                <Redirect
                    to={"eidentify/success" + this.props.location.search}
                />
            );
        }
        if (this.state.error) {
            return <Redirect to="eidentify/error" />;
        }
        if (this.state.redirect) {
            if (this.state.error) {
                return <Redirect to="/eidentify/error" />;
            } else if (this.state.return) {
                const from =
                    (this.props.location!.state &&
                        this.props.location!.state.from) ||
                    "/";
                return <Redirect to={from} />;
            }
            return (
                <Redirect to={"/eidentify/success" + this.state.routeParams} />
            );
        }

        if (code) {
            return (
                <Redirect
                    to={"eidentify/success" + this.props.location.search}
                />
            );
        }

        // tslint:disable-next-line:no-any
        try {
            if (cordova && !this.state.isInAppBrowserOpen) {
                this.openInAppBrowser();
                return <div />;
            }
        } catch (e) {
            logger.info("No Cordova");
        }

        return (
            <div
                className="eidentify-page"
                style={{ marginTop: isWithdrawIdentify ? "2em" : 0 }}
            >
                <FullPageSpinner
                    loading={this.state.loading || this.props.loadingData}
                />
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid item xs={12} sm={10} md={6}>
                            <Typography align="center">
                                Tunnistautumispalvelun tarjoaa Telia.
                            </Typography>
                            <Banks
                                providerData={this.props.providerData}
                                handleClick={this.handleClick}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IEIdentifyPageStateProps => {
    return {
        // ...mapStateToProps
        providerData: getEIdentifyProviders(state),
        redirectUri: getEIdentifyRedirectUri(state),
        loadingData: getEIDentifyLoading(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IEIdentifyPageDispatchProps => {
    return {
        // ...mapDispatchToProps
        SetHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        LoadProviderData: () => {
            return dispatch(startLoadingEIdentifyProviders());
        },
        LoadEIdentifyRedirecturi: (requestType: number, id: number) => {
            return dispatch(startLoadingEIdentifyRedirectUri(requestType, id));
        },
        ShowBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EIdentifyPage);



// WEBPACK FOOTER //
// ./src/views/eidentify/EIdentifyPage.tsx